import React from 'react';
import SimpleCard from './SimpleCard';
import { SimpleCardData } from '../common/types';

interface SimpleCardContainerProps {
    cards: SimpleCardData[];
}

const SimpleCardContainer: React.FC<SimpleCardContainerProps> = ({ cards }) => {
    return (
        <div className='grid grid-cols-[repeat(auto-fill,270px)] justify-center gap-5'>
            {cards.map((card, index) => (
                <SimpleCard key={index} image={card.image} title={card.title} count={card.count} />
            ))}
        </div>
    );
};

export default SimpleCardContainer;
